<template>

    <div class="view pt-[130px] z-[4] bg-white">

        <img class="absolute top-0 left-0 w-full h-full object-cover" src="@/assets/img/hello-bg.png" loading="lazy">

        <div class="relative">
            <div class="p-[30px] max-w-[335px] mx-auto text-center text-white h-[205px] relative">
                <div class="hello-bg absolute top-0 left-0 w-full h-full"></div>
                <div class="relative">
                    <h1 class="md:text-[30px] text-[30px] font-bold mb-[30px] font-title">KPMG-me quiz</h1>
                    <p>
                        Curious about how your personality<br> can impact your career path?
                    </p>
                </div>
            </div>
            <div class="flex justify-center -translate-y-1/2">
                    <Button color="rose" @click="$store.commit('showConfirm')">
                        Take the quiz
                        <font-awesome-icon icon="fa-regular fa-arrow-right" />
                    </Button>
                </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/Button.vue';

export default {
    name: 'HelloPage',
    components: {
        Button,
    },
    data() {
        return {
            isModalVisible: false
        };
    },
}
</script>

<style>
    .hello-bg {
        opacity: 62%;
        background: transparent linear-gradient(239deg, rgba(113, 19, 234, 1) 0%, rgba(51, 23, 196, 1) 100%) 0% 0% no-repeat padding-box;
    }
</style>